"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.scrollToElement = exports.scrollTo = void 0;

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _isNaN = _interopRequireDefault(require("lodash/isNaN"));

var hasWindow = function hasWindow() {
  return typeof window !== 'undefined';
};

var scrollTo = function scrollTo(offset, behavior) {
  if (behavior === void 0) {
    behavior = 'smooth';
  }

  if (hasWindow()) {
    window.scroll({
      top: offset,
      behavior: behavior
    });
  }
};

exports.scrollTo = scrollTo;

var scrollToElement = function scrollToElement(element, options) {
  if (options === void 0) {
    options = {};
  }

  if (!hasWindow() || !element) {
    return;
  }

  var scrollElement = element;

  if ((0, _isString["default"])(element)) {
    scrollElement = document.querySelector(element);
  }

  if (!scrollElement) {
    return;
  }

  var offset = scrollElement.offsetTop;

  while (scrollElement.offsetParent && !(0, _isNaN["default"])(scrollElement.offsetParent.offsetTop)) {
    scrollElement = scrollElement.offsetParent;
    offset += scrollElement.offsetTop;
  }

  if ((0, _isNumber["default"])(options.offset)) {
    offset += options.offset;
  }

  scrollTo(offset, options.behavior);
};

exports.scrollToElement = scrollToElement;